import Icon from './icon'

export { Icon }
